import { useEffect, useState } from 'react';
import httpClient from '../services/http';
import { APIUtils } from '../utils/apiutils';
import { CUSTOM_EVENTS } from '../utils/constants';

const useFetchTestCenters = () => {
    const [testCenters, setTestCenters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        const bootstrapApplication = async () => {
            setLoading(true);
            try {
                const res = await httpClient.get(APIUtils.getAPIEndpoint('test-centers')).then(res => res.data);
                if (res.status === 'success') {
                    setTestCenters(res.data);
                }
            } catch (e) {
                console.log(e);
                setError(e);
            } finally {
                setLoading(false);
            }
        };
        bootstrapApplication();

        document.addEventListener(CUSTOM_EVENTS.REFETCH_TEST_CENTERS, bootstrapApplication, { signal: controller.signal });

        return () => {
            controller.abort();
        };
    }, []);

    return { testCenters, loading, error };
};

export default useFetchTestCenters;